// NotFound.js
import React, { useEffect, useRef, useState } from 'react';
import './css/NotFound.css'; // Import the CSS file for styling

function NotFound() {
  const [style, setStyle] = useState({});
  const intervalRef = useRef(null);

  useEffect(() => {
    // Function to generate a random color
    const getRandomColor = () => {
      const random = Math.random();
      if (random < 0.05) return 'black'; // 5% black
      if (random < 0.10) return 'gray'; // 15% gray
      return 'white'; // 80% white
    };

    // Function to generate a random opacity between 0.2 and 2.0
    const getRandomOpacity = () => Math.random() * 1.8 + 0.2;

    // Function to update the style every 200ms
    const updateStyle = () => {
      setStyle({
        opacity: getRandomOpacity(),
        color: getRandomColor()
      });
    };

    intervalRef.current = setInterval(updateStyle, 100);

    return () => clearInterval(intervalRef.current);
  }, []);

  // Create multiple spans and scanlines for the VHS effect
  const text = "Welcome to the 404 Page.";
  const spans = Array(5).fill(null).map((_, index) => <span key={index}>{text}</span>);
  const scanlines = Array(70).fill(null).map((_, index) => <div key={index} className="scanline"></div>);

  return (
    <div className="not-found">
      <div className="buzz_wrapper">
        <div className="text" style={style}>
          {spans}
        </div>
        {scanlines}
      </div>
      <div className="footer">
        <div className="footer-column">
          <h2>Find me there</h2>
          <ul>
            <li><a href="https://piradite.nekoweb.org" target="_top">* HOME PAGE</a></li>
            <li><a href="https://discord.com" target="_top">* DISCORD: piradite</a></li>
            <li><a href="https://github.com/piradite" target="_top">* GITHUB</a></li>
            <li><a href="mailto:oliviamaxw@gmail.com" target="_blank">* oliviamaxw@gmail.com</a></li>
          </ul>
        </div>
        <div className="footer-column">
          <h2>About Me</h2>
          <ul>
            <li><a href="https://piradite.nekoweb.org/holy.html" target="_top">I OFTEN CODE THE MOST RANDOM STUFF EVERYDAY LOL!!</a></li>
            <li><a href="https://piradite.nekoweb.org" target="_top">© PIRADITE 2024</a></li>
          </ul>
        </div>
        <div className="footer-column">
          <h2>Public Projects</h2>
          <ul>
            <li><a href="https://serenote.vercel.app/" target="_blank">* Note Making App</a></li>
            <li><a href="https://passoli.vercel.app/" target="_blank">* Password Generator</a></li>
            <li><a href="https://relationshipa.vercel.app/" target="_blank">* Data Visualization</a></li>
            <li><a href="https://optim-beta.vercel.app/" target="_blank">* Funny little 2000s thing</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
